<template>
  <div
    v-if="$data.$_renders"
    v-bind="$_attributesWithoutProps"
    v-on="$listeners"
  >
    <slot
      name="default"
      v-bind:value="value"
      v-bind:input="$_input"
      v-bind:blur="$_blur"
      v-bind:change="$_change"
    >
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    value:          { required: true },
    update:         { type: Function, required: true },
    delayMsecToFix: { type: Number, default: 500 },
  },

  data() {
    return {
      $_lastInputValue: undefined,
      $_updateReservationId: undefined,
      $_isLastUpdateSuccesfull: undefined,
      $_renders: undefined,
    };
  },

  computed: {
    $_attributesWithoutProps() {
      let attributesWithoutProps = { ...this.$attrs };
      delete attributesWithoutProps.value;
      delete attributesWithoutProps.update;
      delete attributesWithoutProps.delayMsecToFix;
      return attributesWithoutProps;
    },
  },

  created() {
    this.$_reset();
  },

  methods: {
    $_reset() {
      this.$data.$_renders = true;
      this.$data.$_isLastUpdateSuccesfull = true;
    },

    $_input(value) {
      this.$data.$_lastInputValue = value;
      if (this.$data.$_updateReservationId !== undefined) {
        window.clearTimeout(this.$data.$_updateReservationId);
        this.$data.$_updateReservationId = undefined;
      }
      this.$data.$_updateReservationId = window.setTimeout(
        () => {
          this.$_change(this.$data.$_lastInputValue);
          this.$data.$_updateReservationId = undefined;
        },
        this.delayMsecToFix,
      );
    },

    $_blur() {
      if (this.$data.$_updateReservationId !== undefined) {
        window.clearTimeout(this.$data.$_updateReservationId);
        this.$data.$_updateReservationId = undefined;
        this.$_change(this.$data.$_lastInputValue);
      }
      if (!this.$data.$_isLastUpdateSuccesfull) {
        this.$data.$_renders = false;
        this.$nextTick(this.$_reset);
      }
    },

    $_change(value) {
      this.$data.$_isLastUpdateSuccesfull = this.update(value);
    },
  },
}
</script>
